import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ControlPropertyHandler } from './control-property-handler';
import { ControlNameService } from '../services/control-name.service';
import { AbstractPropertyEditor } from '../types';

@Injectable({
  providedIn: 'root'
})
export class ControlNamePropertyService implements ControlPropertyHandler<any> {
  propertyName: string = 'name';

  constructor(private nameService: ControlNameService) {}

  handleData(data: any, editor: AbstractPropertyEditor): Observable<any> {
    return this.nameService.handleName(data, editor);
  }
}
